<template>
  <div class="register">
    <TrialV2 sceneCode="6" title="申请体验"/>
  </div>
</template>

<script>
import TrialV2 from '@/components/trialV2.vue'

export default {
  components: { TrialV2 },
  data () {
    return {
      redirect: this.$route.query?.redirect || ''
    }
  }
}
</script>

<style lang='scss' scoped>
.register {
  width: 100%;
  min-width: $container-width;
  height: Translate(690px);
  background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_申请体验.png") no-repeat;
  background-position: center center;
  background-size: cover;
  padding: Translate(42px) 0 Translate(64px);
  box-sizing: border-box;
}
</style>
